/**
 * Ist ein gespeicherter Feed-Befund noch aussagekraeftig?
 *
 * Hintergrund: von 58 Feeds mit Befund waren zum Zeitpunkt der Analyse sechs
 * juenger als sieben Tage, das Median-Alter lag bei 47 Tagen, der aelteste bei
 * 126. Die Seite rendert das bisher kommentarlos als Gegenwart.
 */

/** Ab wann ein Befund allein wegen seines Alters als veraltet gilt. */
export const STALE_AFTER_DAYS = 7;

export type StaleReason = 'age' | 'sync';

export interface FreshnessInput {
  snapshotCreatedAt: string | null;
  lastSyncedAt: string | null;
  now: Date;
}

function parse(value: string | null): number | null {
  if (!value) return null;
  const ms = Date.parse(value);
  return Number.isNaN(ms) ? null : ms;
}

export function isSnapshotStale({ snapshotCreatedAt, lastSyncedAt, now }: FreshnessInput): StaleReason | null {
  const created = parse(snapshotCreatedAt);
  if (created === null) return null;

  // Sync zuerst: der konkretere Grund und die bessere Begruendung.
  const synced = parse(lastSyncedAt);
  if (synced !== null && synced > created) return 'sync';

  const ageDays = (now.getTime() - created) / (24 * 3600 * 1000);
  return ageDays > STALE_AFTER_DAYS ? 'age' : null;
}
